import {themr} from '@friendsofreactjs/react-css-themr';
import identifiers from '../identifiers';

import IconButtonDropDown from './iconButtonDropDown';
import style from './style.css';

export default themr(identifiers.iconButtonDropDown, style)(IconButtonDropDown);
